import { render } from "./AuthCard.vue?vue&type=template&id=ef23df06&scoped=true"
import script from "./AuthCard.vue?vue&type=script&lang=js"
export * from "./AuthCard.vue?vue&type=script&lang=js"

import "./AuthCard.vue?vue&type=style&index=0&id=ef23df06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef23df06"]])

export default __exports__